module.exports = __webpack_public_path__ + "img/Chat_record.3b83e154.svg";